/**
 * 일정 화면의 기본 우클릭 메뉴. 그리드/목록/허브 행이 직접 처리하지 않은
 * 우클릭(빈 곳·툴바·사이드바·읽기 패널)에도 인앱 메뉴를 띄운다.
 */
import { showContextMenu } from './context-menu.js';
import { navigate } from './calendar-spa.js';
import { refreshOrReload } from './calendar-history.js';

function txt(sel) { const el = document.querySelector(sel); return el ? el.textContent.trim() : ''; }
function click(sel) { const el = document.querySelector(sel); if (el) el.click(); }
function go(sel) { const a = document.querySelector(sel); if (a) navigate(a.href); }

export function setupCalendarContextMenu() {
    if (!['calGrid', 'calList', 'projHub'].some((id) => document.getElementById(id))) return;
    document.addEventListener('contextmenu', (e) => {
        if (e.defaultPrevented) return; // 행/바가 이미 자기 메뉴를 띄움
        if (e.target.closest('input, textarea, select, [contenteditable="true"], .ctx-menu, .cal-sel-pop, .att-dp-pop')) return;
        const modal = e.target.closest('#calendarModal');
        const items = [];
        if (modal) {
            const read = document.getElementById('calPeekRead');
            if (!read || read.hidden) return; // 편집 폼에서는 브라우저 메뉴 (텍스트 편집)
            const editBtn = document.getElementById('calReadEdit');
            if (editBtn && !editBtn.hidden) items.push({ label: editBtn.textContent.trim(), onClick: () => editBtn.click() });
            const copy = document.getElementById('calCopyLink');
            if (copy && !copy.hidden) items.push({ label: copy.title || copy.textContent.trim() || '링크 복사', onClick: () => copy.click() });
            const page = document.getElementById('calOpenPage');
            if (page && !page.hidden) items.push({ label: page.title || page.textContent.trim() || '페이지로 열기', onClick: () => page.click() });
            const hide = document.getElementById('calReadHide');
            if (hide && !hide.hidden) items.push({ label: hide.textContent.trim(), onClick: () => hide.click() });
            const del = document.getElementById('calReadDelete');
            if (del && del.style.display !== 'none') items.push({ separator: true }, { label: del.textContent.trim(), danger: true, onClick: () => del.click() });
        } else if (document.getElementById('projHub')) {
            const M = document.getElementById('projHub').dataset;
            items.push(
                { label: M.lNewTask || '새 작업', hint: 'Enter', onClick: () => { const q = document.getElementById('calpQuickInput'); if (q) q.focus(); } },
                { label: M.lAdd || txt('#calpAddEvent') || '일정 추가', onClick: () => click('#calpAddEvent') },
                { separator: true },
                { label: M.lList || '목록', onClick: () => go('.calp-tabs a[href*="view=list"]') },
                { label: M.lTimeline || '타임라인', onClick: () => go('.calp-tabs a[href*="view=timeline"]') },
                { label: M.lProps || txt('#calpPropsBtn') || '속성', onClick: () => click('#calpPropsBtn') },
                { separator: true },
                { label: M.lRefresh || '새로고침', onClick: () => refreshOrReload() },
            );
        } else {
            const main = document.querySelector('.cal-main');
            const M = main ? main.dataset : {};
            items.push(
                { label: M.lNew || '새 일정', onClick: () => { if (window.openCalendarCreate) window.openCalendarCreate(''); } },
                { separator: true },
                { label: M.lToday || '오늘', onClick: () => go('.cal-nav-today') },
                { label: M.lPrev || '이전 달', hint: '←', onClick: () => go('#calNavPrev') },
                { label: M.lNext || '다음 달', hint: '→', onClick: () => go('#calNavNext') },
                { separator: true },
                { label: M.lMonth || '월간', onClick: () => go('.cal-view-seg a[href*="view=month"]') },
                { label: M.lList || '목록', onClick: () => go('.cal-view-seg a[href*="view=list"]') },
                { separator: true },
                { label: M.lRefresh || '새로고침', onClick: () => refreshOrReload() },
            );
        }
        if (!items.length) return;
        e.preventDefault();
        showContextMenu(e.clientX, e.clientY, items);
    });
}
